"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonNames = void 0;
var AddonNames;
(function (AddonNames) {
    AddonNames["WEBINAR"] = "WEBINAR";
    AddonNames["KINESCOPE"] = "KINESCOPE";
})(AddonNames || (exports.AddonNames = AddonNames = {}));
//# sourceMappingURL=addon-names.enum.js.map